( function ( $ ) {
	'use strict';

	const $leadercard = $( '.leader-card__meta' );

	$leadercard.on( 'click', function () {
		const $this = $( this );
		const $leadercontent = $this.parent().next();

		// Close all other leader cards except the one clicked
		$( '.leader--open' ).not( $this.closest( '.leader-card' ) ).removeClass( 'leader--open' ).find( '.leader-card__content' ).slideUp( 200 );

		// Toggle the open class and slide toggle the content for the clicked leader card
		$this.closest( '.leader-card' ).toggleClass( 'leader--open' );
		$leadercontent.slideToggle( 200 );
	} );

} )( jQuery );
